import { Validator } from '@vista-digital/validator';
import { cdnStandardAssetOptionsValidator } from '../../../../validators/cdn-asset-options';
export const defaultEventHeroBannerCdnOptions = {
    heroBannerImage: { width: 1920 },
    posterImage: { width: 200 }
};
export const eventHeroBannerCdnOptionsValidator = Validator.object({
    heroBannerImage: cdnStandardAssetOptionsValidator,
    posterImage: cdnStandardAssetOptionsValidator
});
